<template>
  <Modal
    persistent
    :title="$t('project.add')"
    :hide-footer="!mainProject"
    @ok="save"
    :value="value"
    :okText="$t('project.add')"
    @input="$emit('input', $event)"
  >
    <PageTitle :description="$t('project.addDescription')"></PageTitle>
    <div class="o-card__height--400">
      <MainProjectSearch
        v-model="mainProject"
        clearable
        :label="$t('mainProject.title')"
        :placeholder="$t('mainProject.title')"
        :class="{ 'vs-invalid': validActivated && !mainProject }"
      ></MainProjectSearch>
    </div>
  </Modal>
</template>

<script>
import Modal from "../Base/Modal.vue";
import PageTitle from "@/components/Shared/PageTitle/index.vue";
import Requests from "@/services/Requests";
import MainProjectSearch from "@/components/Searches/MainProjectSearch.vue";
export default {
  components: {
    Modal,
    PageTitle,
    MainProjectSearch,
  },
  props: {
    value: {
      default: false,
    },
    edit: {
      default: false,
      type: Boolean,
    },
    form: {
      default: () => ({
        id: null,
        title: "",
      }),
    },
  },
  data() {
    return {
      mainProject: null,
      validActivated: false,
    };
  },
  watch: {
    mainProject(value) {
      this.validActivated = value ? true : false;
    },
  },

  methods: {
    async save(loading) {
      if (!this.validation()) {
        return;
      }
      loading(true);
      const response = await Requests.ProjectMainProject.Create({
        mainProjectId: this.mainProject.id,
        projectId: this.form.id,
        isActive: true,
      });
      if (response.message === "OK") {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("mainProject.success"),
          variant: "success",
          duration: 2500,
        });
        this.$emit("refresh");
        this.$emit("input", false);
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    validation() {
      this.validActivated = true;
      if (this.mainProject) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style></style>
